@if (isAuthorized() && !fusionStatus.error()) {
    @if (collapsed()) {
        <hive-app-navigation-popup-action icon="fusion.svg" ariaLabel="Fusion Status">
            <ng-template hiveAppNavigationPopupContent>
                <div class="fusion-status-panel">
                    <ng-container [ngTemplateOutlet]="content" />
                </div>
            </ng-template>
        </hive-app-navigation-popup-action>
    } @else {
        <div class="fusion-status-panel fusion-status-panel--inline hive-theme-dark">
            <ng-container [ngTemplateOutlet]="content" />
        </div>
    }
}

<ng-template #content>
    @if (initialLoad()) {
        <hive-label-skeleton size="small" [width]="75" class="label-skeleton"></hive-label-skeleton>
        <hive-label-skeleton size="large" [width]="100" class="label-skeleton"></hive-label-skeleton>
    } @else {
        <fusion-status [fusionStatus]="displayedFusionStatus()" />
        @if (displayedFusionStatus()?.inFleet > 0) {
            <div class="fleet-card-info">
                <hive-load-indicator
                    [loadBars]="[(displayedFusionStatus()?.inFleet * 100) / displayedFusionStatus()?.total]"
                    state="success"
                ></hive-load-indicator>
            </div>
        }

        @if (displayedFusionStatus()?.inFleet === 0) {
            <hive-button
                label="Create Fleet"
                size="small"
                width="fit-parent"
                routerLink="/administration/fusion-fleet"
                (click)="ampli.createFleetClickedFromLeftMenuWidget()"
            ></hive-button>
        } @else {
            <hive-button
                label="Fleet Administration"
                size="small"
                width="fit-parent"
                emphasis="secondary"
                routerLink="/administration/fusion-fleet"
                (click)="ampli.goToFleetAdministrationPageFromLeftMenuWidget()"
            ></hive-button>
        }
    }
</ng-template>
